<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
    name: 'App',
    mounted() {
        this._resizeFont()
        window.addEventListener('resize', this._resizeFont)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this._resizeFont)
    },
    methods: {
        _resizeFont() {
            // 动态设置根字体：1920px 设计稿 → 16px 基准
            // 移动端(<768px) 自动缩放到 14px，非常小屏(<375px) 缩到 12px
            const w = window.innerWidth
            let base
            if (w >= 1920) {
                base = 16
            } else if (w >= 1200) {
                base = 15
            } else if (w >= 768) {
                base = 14
            } else if (w >= 375) {
                base = 14
            } else {
                base = 12
            }
            document.documentElement.style.fontSize = base + 'px'
        }
    }
};
</script>
<style lang="scss">
/* ════════════════════════════════════════
   FFT/Heat 图表切换过渡（全局）
   ════════════════════════════════════════ */
.chart-switch-enter-active,
.chart-switch-leave-active {
    transition: opacity 0.2s ease, transform 0.2s ease;
}
.chart-switch-enter {
    opacity: 0;
    transform: translateY(6px);
}
.chart-switch-leave-to {
    opacity: 0;
    transform: translateY(-6px);
}

/* 按钮样式 — 用 :not 排除所有弹窗、popper、picker 容器内的按钮 */
.el-button--primary {
    background: rgba(0,0,0,0);
    color: #d9d9d9;
    border: 0;
    .icon {
        fill: #d9d9d9;
    }
}
.el-button--primary:hover {
    color: #FFF;
    background: rgba(0,0,0,0);
    .icon {
        fill: #FFF;
    }
}

.el-button--primary:active {
    background: rgba(0,0,0,0);
    color: #d9d9d9;;
     border: 0;
 }

.el-button--primary:focus {
    background: rgba(0,0,0,0);
    color: #d9d9d9;
    border: 0;
  }

/* 排除弹窗内的按钮，恢复默认蓝色样式（含日期选择器的"确定"按钮） */
.el-dialog .el-button--primary,
.el-message-box .el-button--primary,
.el-popper .el-button--primary,
.el-picker-panel .el-button--primary,
.el-picker-panel__footer .el-button,
.el-dropdown-menu .el-button--primary {
    background: #409EFF !important;
    color: #ffffff !important;
    border: 1px solid #409EFF !important;
}
.el-dialog .el-button--primary:hover,
.el-message-box .el-button--primary:hover,
.el-popper .el-button--primary:hover,
.el-picker-panel .el-button--primary:hover,
.el-picker-panel__footer .el-button:hover,
.el-dropdown-menu .el-button--primary:hover {
    background: #66b1ff !important;
    border-color: #66b1ff !important;
    color: #ffffff !important;
}

.el-button--success{
    background: #08d13e;
    color: white;
    border: 0;
}
.el-button--danger{
    background: #c90808;
    color: white;
    border: 0;
}

.el-button--warning{
    background: #ef9510;
    color: white;
    border: 0;
}

.el-button--info{
    background: #0074ad;
    color: white;
    border: 0;
}

/*滚动条样式*/
::-webkit-scrollbar {
    width: 4px;
    height: 0;
    background-color: #ebeef5;
}
::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: #ccc;
}
::-webkit-scrollbar-track{
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 3px;
    background: rgba(255, 255, 255, 1);
}


  /*加载样式*/
  .el-loading-mask{
      background-color: rgba(255,255,255,0.7);
  }
/*//设置图标颜色*/
  .el-loading-spinner .path{
      stroke: #2762cb;
  }
/*//设置文字颜色*/
  .el-loading-spinner .el-loading-text{
      color: #2762cb;
  }


.el-select-dropdown {
    border: none;
    color: black;
    /*background-color: rgba(1, 28, 82, 0.8);*/
}

/* Element UI dropdown 必须高于地图层（天地图内部 DOM 可能覆盖） */
.el-dropdown-menu {
    z-index: 5000 !important;
    background: linear-gradient(180deg, #1a3354 0%, #162c4e 100%) !important;
    border: 1px solid rgba(212, 175, 55, 0.25) !important;
    border-radius: 8px !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.45) !important;
    padding: 6px 0 !important;
}

.el-dropdown-menu__item {
    color: #c8d6e5 !important;
    padding: 10px 20px !important;
    font-size: 14px !important;
    transition: all 0.2s ease;
    border-left: 2px solid transparent;
    margin: 2px 8px !important;
    border-radius: 4px;
    width: auto !important;
}

.el-dropdown-menu__item:hover {
    background: rgba(212, 175, 55, 0.12) !important;
    color: #e2e8f0 !important;
    border-left-color: #d4a853 !important;
}

.el-popper .popper__arrow {
    border-bottom-color: #1a3354 !important;
}

.el-popper .popper__arrow::after {
    border-bottom-color: #1a3354 !important;
}

/*//输入框*/
  .el-input__inner{
      color:black;
      /*border-color: white;*/
      /*background-color: rgba(255, 255, 255, 0.8);*/
  }
/*//聚焦时的样式*/
  .el-select .el-input.is-focus .el-input__inner{
      /*border-color: white;*/
      /*background-color: rgba(1, 28, 82, 0.8);*/
      /*color:white;*/
  }
/*//下拉框选中*/
  .el-select-dropdown__item {
      color: black;
      /*background-color: rgba(0,0,0,0.1);*/
  }

  .el-select-dropdown__item:hover{
      color:black;
      background-color: rgba(0,0,0,0.1);
  }


//确认框样式
.confirm {
    border-radius: 5px;
    .el-message-box__btns {
        .el-button:nth-child(1) {
            float:right;
        }
        .el-button:nth-child(2) {
            margin-right:10px;
            color: white;
            background-color:#2d8cf0;
            border-color:#2d8cf0;
        }
    }
}




#app {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}



/* common0.css */
/* CSS Document */
* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box
}

html {
    font-size: 16px; /* JS 会动态覆盖，这里是默认值 */
}

*, body {
    padding: 0px;
    margin: 0px;
    font-family: "微软雅黑";
}

body {
    background: linear-gradient(160deg, #e8f0fe 0%, #f0f4ff 25%, #eef2fb 50%, #e3ebf8 75%, #f5f7fc 100%);
    color: #666;
    font-size: 0.875rem; /* 14/16 = 0.875rem，跟随根字体缩放 */
}

/* ══════════════════════════════════════════
   Element UI 全局字体跟随根字体
   ══════════════════════════════════════════ */
.el-button,
.el-input__inner,
.el-select-dropdown__item,
.el-table,
.el-form-item__label,
.el-message,
.el-notification,
.el-dialog__title,
.el-dialog__body,
.el-tabs__item,
.el-menu-item,
.el-submenu__title,
.el-dropdown-menu__item,
.el-tag,
.el-badge__content,
.el-tooltip__popper,
.el-popover,
.el-cascader__label,
.el-checkbox__label,
.el-radio__label,
.el-pagination button,
.el-pager li,
.el-step__title,
.el-tree-node__label,
.el-card__body,
.el-alert__title,
.el-alert__description,
.el-loading-text,
.el-radio-button__inner {
    font-size: inherit;
}

/* ══════════════════════════════════════════
   全局移动端适配 (≤768px)
   ══════════════════════════════════════════ */
@media (max-width: 768px) {
    /* Element UI 弹窗移动端全屏 */
    .el-dialog {
        width: 100% !important;
        max-width: 100vw !important;
        margin: 0 !important;
        border-radius: 0 !important;
    }
    .el-dialog__wrapper {
        overflow: hidden !important;
    }

    /* Element UI 消息提示移动端缩小 */
    .el-message {
        min-width: auto !important;
        max-width: 90vw;
        padding: 0.625rem 1rem;
    }

    /* 下拉菜单移动端适配 */
    .el-select-dropdown {
        max-width: 90vw;
    }

    /* tooltip 移动端适配 */
    .el-tooltip__popper {
        max-width: 80vw;
    }

    /* Element UI 表格/表单组件字体跟随根字体 */
    .el-table {
        font-size: inherit;
    }
    .el-form-item__label {
        font-size: inherit;
    }
}



</style>



// WEBPACK FOOTER //
// src/App.vue